import { useMemo, useState } from "react";
import { ActivityFeed } from "@/components/application/activity-feed/activity-feed";
import { ActivityItemView } from "@/components/application/activity-feed/activity-item";
import { ActivityFiltersBar } from "@/components/application/activity-feed/activity-filters";
import { activityService } from "@/data/mock-activities";
import type { ActivityFilters } from "@/types/activity";
import { useTranslation } from "react-i18next";

export const ReceiverActivityPage = () => {
    const { t } = useTranslation(['pages:activity', 'common']);
    const base = useMemo(() => activityService.getByAudience("receiver"), []);
    const [filters, setFilters] = useState<ActivityFilters>({ readState: "all" });

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold text-primary">{t('receiver.title')}</h1>
                <p className="text-tertiary mt-1">{t('receiver.subtitle')}</p>
            </div>

            <ActivityFiltersBar value={filters} onChange={setFilters} />

            <ActivityFeed
                items={base}
                filters={filters}
                renderItem={(item) => <ActivityItemView item={item} />}
            />
        </div>
    );
};

export default ReceiverActivityPage;


